import { render, staticRenderFns } from "./ClickOnceButton.vue?vue&type=template&id=6ba785d5&"
import script from "./ClickOnceButton.vue?vue&type=script&lang=js&"
export * from "./ClickOnceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports